import { render, staticRenderFns } from "./CustomBlock.html?vue&type=template&id=21c713eb&scoped=true&"
import script from "./CustomBlock.component.js?vue&type=script&lang=js&"
export * from "./CustomBlock.component.js?vue&type=script&lang=js&"
import style0 from "./CustomBlock.css?vue&type=style&index=0&id=21c713eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c713eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
